import { AccountStatus } from "./account-status.model";

export type UnternehmenSearchFilter = {
  openForInvitation: boolean;
  searchParameter: string;
  accountStatus: keyof typeof AccountStatus | null;
  beraterId: string | null;
};

export type UnternehmenSearchRequest = {
  page: number;
  size: number;
  filter: UnternehmenSearchFilter;
};

export function createTermAndInvitationStatusBasedUnternehmenSearchRequest(
  searchTerm: string,
  page: number,
  size: number,
  openForInvitation: boolean,
): UnternehmenSearchRequest {
  page = page ? page - 1 : 0;
  size = size || 10;

  const filter: UnternehmenSearchFilter = {
    openForInvitation: openForInvitation,
    searchParameter: searchTerm,
    accountStatus: null,
    beraterId: null,
  };

  return {
    page: page,
    size: size,
    filter: filter,
  };
}
